import TableFilter from '../table-models/TableFilter';

export const defaultExamFilters: TableFilter[] = [
    { field: 'externalName', label: 'Name', value: '' },
];
